import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const HeaderCell = ({
    onClick,
    isSorted,
    className,
    text,
    children,
    refCallback
}) => (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
        role="button"
        tabIndex={0}
        className={classNames(
            'ui-table__cell',
            'tn-napsTable__cell',
            'tn-napsTable__cell_header',
            className,
            { 'ui-table__cell_sorted': isSorted, }
        )}
        onClick={onClick}
        ref={refCallback}
    >
        <span className="header_title">
            {text || children}
        </span>
    </div>
);

HeaderCell.defaultProps = {
    text: null,
    children: null,
    className: '',
    refCallback: null,
};

HeaderCell.propTypes = {
    isSorted: PropTypes.bool.isRequired,
    text: PropTypes.string,
    children: React.PropTypes.oneOfType([
        React.PropTypes.arrayOf(React.PropTypes.node),
        React.PropTypes.node,
    ]),
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    refCallback: PropTypes.func,
};

export default HeaderCell;



// WEBPACK FOOTER //
// ./src/js/napsTable/HeaderCell.js